import {LAST_CLEAN_STORAGE_KEY} from "./LocalStorageKeys";

/**
 * Service to manage the storage of the last date of data cleaning
 */
class DateCleanStorage {

    private _store = localStorage;

    /**
     * Returns the last cleaning date
     */
    public getLastCleaningDate(): Date | undefined {
        let lastCleaningDate: Date | undefined = undefined;
        const jsonDate = this._store.getItem(LAST_CLEAN_STORAGE_KEY);
        if(jsonDate){
            try {
                lastCleaningDate = new Date(JSON.parse(jsonDate));
            } catch (e) {
                console.log(e);
            }
        }
        return lastCleaningDate;
    }

    /**
     * Adds a new cleaning date to the local storage
     * @param newDate
     */
    public createLastCleaningDate(newDate: Date): boolean {
        let isAdd = false;
        try {
            const stringify = JSON.stringify(newDate);
            this._store.setItem(LAST_CLEAN_STORAGE_KEY, stringify);
            isAdd = true;
        } catch (e) {
            console.log(e);
        }
        return isAdd;
    }

    /**
     * Removes the last cleaning date from the local storage
     */
    public deleteLastCleaningDate(): boolean {
        let isDelete = false;
        try{
            this._store.removeItem(LAST_CLEAN_STORAGE_KEY);
            isDelete = true;
        } catch(err) {
            console.log(err);
        }
        return isDelete;
    }
}

export default new DateCleanStorage();
